import {
  NATIVE_TITLE_SIZE,
  v2Text,
  v2TextWithPetName,
} from '@flows/configs/petHealthV2/steps/elements/shared'
import * as schemaUtils from '@flows/configs/shared/schemaUtils'
import type { ElementFragment } from '@flows/configs/shared/stepFragments'
import type { StepConfigParams } from '@flows/configs/types'
import { BaseSchema_PetHealthV2GetsafeDe } from '@flows/insurance/schemas'

export const petTypeElements = (params: StepConfigParams) =>
  ({
    elements: [
      {
        type: 'title',
        text: v2TextWithPetName(params, 'steps.pet_type.title'),
        size: NATIVE_TITLE_SIZE,
      },
      {
        type: 'radioCardSet',
        shouldTrackValues: true,
        layout: 'wide',
        variant: 'chip',
        name: params.helperFunctions.getParamPath('species'),
        options: [
          {
            value: 'cat',
            title: v2Text('steps.pet_type.cat'),
            imagePath:
              'https://cdn.sanity.io/images/p4gom3ch/production/a813c921968aaa6aebfe9e1df4a539b965c5db31-126x126.png',
          },
          {
            value: 'dog',
            title: v2Text('steps.pet_type.dog'),
            imagePath:
              'https://cdn.sanity.io/images/p4gom3ch/production/1f8b4d02e88fa45466f05aafd8b287c2c0fd4798-126x126.png',
          },
        ],
      },
    ],
    schema: schemaUtils.generateZodObjectFromPaths({
      [params.helperFunctions.getParamPath('species')]:
        BaseSchema_PetHealthV2GetsafeDe.shape.species,
    }),
  }) as const satisfies ElementFragment
